(function () {
  function populateProductInquiry() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var params = new URLSearchParams(window.location.search);
    var productTitle = params.get('product');
    if (params.get('inquiry') !== 'price' || !productTitle) return;

    var inquiryField = form.querySelector('[data-product-inquiry]');
    var titleInput = form.querySelector('[data-product-inquiry-title]');
    var urlInput = form.querySelector('[data-product-inquiry-url]');
    var skuInput = form.querySelector('[data-product-inquiry-sku]');
    var messageInput = form.querySelector('#ContactForm-body');
    if (!inquiryField || !titleInput || !urlInput || !skuInput) return;

    inquiryField.hidden = false;
    titleInput.disabled = false;
    titleInput.value = productTitle;
    urlInput.disabled = false;
    urlInput.value = params.get('product_url') || '';
    skuInput.disabled = false;
    skuInput.value = params.get('sku') || '';

    if (messageInput && !messageInput.value.trim()) {
      messageInput.value = 'I would like to request this bottle.';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populateProductInquiry);
  } else {
    populateProductInquiry();
  }
})();
